import { render, staticRenderFns } from "./VaNumberTableForm.vue?vue&type=template&id=fc7349c2"
import script from "./VaNumberTableForm.vue?vue&type=script&lang=js"
export * from "./VaNumberTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports